import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { first } from 'rxjs';
import { IEmployeeRole } from 'src/app/employee/employee-roles';
import { EmployeeRoleService } from 'src/app/employee/services/employee-role.service';

@Component({
    selector: 'app-employee-roles',
    templateUrl: './employee-roles.component.html',
    styleUrls: ['./employee-roles.component.css'],
    standalone: false
})
export class EmployeeRolesComponent implements OnInit {

  constructor(
    private route : ActivatedRoute,
    private employeeRoleService : EmployeeRoleService
  ) { }

  employeeRoles : IEmployeeRole[] = [];
  public formGroup!: UntypedFormGroup;
  private editedRowIndex!: number;



  ngOnInit(): void {
    this.employeeRoles = this.route.snapshot.data.employeeRoles as IEmployeeRole[];
  }

  updateList(){
    this.employeeRoleService.listEmployeeRoleRoles({pageNumber: 0, pageSize: 999999})
    .pipe(first())
    .subscribe(response => {
      this.employeeRoles = response.data;
    })
  }

  addHandler({ sender }){
    this.closeEditor(sender);

    this.formGroup = new UntypedFormGroup({
      name: new UntypedFormControl(null, Validators.required),
    });

    sender.addRow(this.formGroup);
  }

  editHandler({ sender, rowIndex, dataItem }){
    this.closeEditor(sender);

    this.formGroup = new UntypedFormGroup({
      name: new UntypedFormControl(dataItem.name, Validators.required),
    });

    this.editedRowIndex = rowIndex;

    sender.editRow(rowIndex, this.formGroup);
  }

  public cancelHandler({ sender, rowIndex }) {
    this.closeEditor(sender, rowIndex);
  }

  public saveHandler(event) {
    const request: any = {
      name: event.formGroup.value.name,
      id: event.dataItem.id ?? null,
    }
    if (!event.dataItem.id){
      this.employeeRoleService.addEmployeeRoleRole(request)
      .subscribe(response => {
        this.updateList();
      });
    } else {
      this.employeeRoleService.updateEmployeeRoleRole(request)
      .subscribe(response => {
        this.updateList();
      });;
    }

    event.sender.closeRow(event.rowIndex);
    
  }

  private closeEditor(grid, rowIndex = this.editedRowIndex) {
    grid.closeRow(rowIndex);
    this.editedRowIndex = undefined;
    this.formGroup = undefined;
  }

  deletionDialogOpened = false;
  private itemToDelete: { id: string } | null = null;

  public removeHandler({ dataItem }) {
    this.itemToDelete = dataItem;
    this.deletionDialogOpened = true;
  }

  public deleteConfirmed() {
    const dataItem = this.itemToDelete;
    this.itemToDelete = null;
    if (!dataItem) return;
    this.employeeRoleService.deleteEmployeeRoleRole(dataItem.id)
    .subscribe(response => {
      this.updateList();
    });;
  }

}
